import axios from 'axios';
function defaultState() {
	return {
		empresas: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setEmpresas(state: { empresas: object[] }, data: object[]) {
		state.empresas = data;
	},
};
const actions = {
	async forgotPassword({ commit, dispatch }, params: { email: string }) {
		try {
			return await axios.post('./api/public/usuarios?forgotPassword=true', params);
		} catch (error) {
			return false;
		}
	},
	async changePassword({ commit, dispatch }, params: { email: string }) {
		try {
			return await axios.post('./api/public/usuarios?changePassword=true', params);
		} catch (error) {
			return false;
		}
	},
	async loadEmpresas({ commit, dispatch }): Promise<boolean> {
		try {
			const response = await axios.get('./api/public/proxy/cgi/etenet_empresas');
			commit('setEmpresas', response.data.items);
			return true;
		} catch (error) {
			return false;
		}
	},
	async loadUsuarios({ commit, dispatch }, params: { start: number; limit: number; data: object }): Promise<boolean> {
		try {
			return await axios.get(`./api/public/proxy/usuarios?start=${params.start}&limit=${params.limit}`, params.data);
		} catch (error) {
			return false;
		}
	},
	async deleteUser({ commit, dispatch }, params: { username: string; data: object[] }): Promise<boolean> {
		try {
			return await axios.delete('./api/public/proxy/usuarios/' + params.username);
		} catch (error) {
			return false;
		}
	},
	async putUser({ commit, dispatch }, params: { usuarios_id: string; data: object[]; edita: boolean }): Promise<boolean> {
		try {
			const url = params.edita ? `./api/public/proxy/usuarios/${params.usuarios_id}` : './api/public/proxy/usuarios';
			return params.edita ? await axios.patch(url, params.data) : await axios.post(url, params.data);
		} catch (error) {
			return false;
		}
	},
	async registerLocal({ commit, dispatch }, params: { nrotel: string; email: string }): Promise<boolean> {
		try {
			params.nrotel = '+54' + params.nrotel;
			params.email = params.email.toLowerCase().trim();
			return await axios.post('./api/public/usuarios', params);
		} catch (error) {
			return false;
		}
	},
	async checkUsuario({ commit, dispatch }, params: object[]): Promise<boolean> {
		try {
			return await axios.post('./api/public/usuarios?check=true', params);
		} catch (error) {
			return false;
		}
	},
	async verificationSMS({ commit, dispatch }, params: { nrotel: string }): Promise<boolean> {
		try {
			params.nrotel = '+54' + params.nrotel;
			return await axios.post('./api/public/usuarios?verificationSMS=true', params);
		} catch (error) {
			return false;
		}
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
